import { render, staticRenderFns } from "./UserButtonGroup.vue?vue&type=template&id=1b3b2398&scoped=true&"
import script from "./UserButtonGroup.vue?vue&type=script&lang=js&"
export * from "./UserButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b2398",
  null
  
)

export default component.exports